"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassthroughGraph = void 0;
var PassthroughGraph = /** @class */ (function () {
    function PassthroughGraph(props, cb) {
        if (props === void 0) { props = {}; }
        if (cb === void 0) { cb = function () { }; }
        this.destroyed = false;
        this.props = props;
        this.cb = cb;
    }
    PassthroughGraph.prototype.update = function () {
        if (this.destroyed) {
            return;
        }
        this.cb.call(null, this.props);
    };
    PassthroughGraph.prototype.listen = function () {
        this.update();
    };
    PassthroughGraph.prototype.destroy = function () {
        if (this.destroyed) {
            return;
        }
        this.destroyed = true;
    };
    PassthroughGraph.prototype.updateExternal = function (props) {
        if (props === void 0) { props = {}; }
        if (this.destroyed) {
            return;
        }
        this.props = props;
        this.update();
    };
    return PassthroughGraph;
}());
exports.PassthroughGraph = PassthroughGraph;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFzc3Rocm91Z2hHcmFwaC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ncmFwaC9wYXNzdGhyb3VnaEdyYXBoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBO0lBSUUsMEJBQVksS0FBa0IsRUFBRSxFQUF1QjtRQUEzQyxzQkFBQSxFQUFBLFVBQWtCO1FBQUUsbUJBQUEsRUFBQSxtQkFBc0IsQ0FBQztRQUYvQyxjQUFTLEdBQUcsS0FBSyxDQUFDO1FBR3hCLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDO1FBQ25CLElBQUksQ0FBQyxFQUFFLEdBQUcsRUFBRSxDQUFDO0lBQ2YsQ0FBQztJQUNPLGlDQUFNLEdBQWQ7UUFDRSxJQUFJLElBQUksQ0FBQyxTQUFTLEVBQUU7WUFDbEIsT0FBTztTQUNSO1FBQ0QsSUFBSSxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUNqQyxDQUFDO0lBQ0QsaUNBQU0sR0FBTjtRQUNFLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQztJQUNoQixDQUFDO0lBQ0Qsa0NBQU8sR0FBUDtRQUNFLElBQUksSUFBSSxDQUFDLFNBQVMsRUFBRTtZQUNsQixPQUFPO1NBQ1I7UUFDRCxJQUFJLENBQUMsU0FBUyxHQUFHLElBQUksQ0FBQztJQUN4QixDQUFDO0lBQ0QseUNBQWMsR0FBZCxVQUFlLEtBQXlCO1FBQXpCLHNCQUFBLEVBQUEsVUFBeUI7UUFDdEMsSUFBSSxJQUFJLENBQUMsU0FBUyxFQUFFO1lBQ2xCLE9BQU87U0FDUjtRQUNELElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFDO1FBQ25CLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQztJQUNoQixDQUFDO0lBQ0gsdUJBQUM7QUFBRCxDQUFDLEFBOUJELElBOEJDO0FBOUJZLDRDQUFnQiJ9